import { render, staticRenderFns } from "./TurnoRoute.vue?vue&type=template&id=0cdb4115"
import script from "./TurnoRoute.vue?vue&type=script&lang=js"
export * from "./TurnoRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports